import React, { useCallback, useState } from "react"

import { CardHeading, Modal } from "components"

import { Formik, Form } from "formik"
import * as yup from "yup"

import TripGeneralForm from "components/Common/Forms/TripGeneral"

import formatDate from "utils/formatDate"
import formatMoney from "utils/formatMoney"
import pick from "lodash/pick"

import { stringifyNumber } from "utils"

import startCase from "lodash/startCase"

const getTripEditModalProps = (data) => {
  const tripGeneral = [
    "id",
    "type",
    "name",
    "code",
    "startDate",
    "endDate",
    "destinations",
    "image",
    "account",
    "agency",
    "agents",
    "leaders",
    "payment",
    "legal",
  ]

  const _data = pick(data, tripGeneral)
  return {
    ..._data,

    startDate: _data?.startDate?.split("T", 1)[0],
    endDate: _data?.endDate?.split("T", 1)[0],
    destinations: data?.destinations?.map((_) => ({
      label: _.name,
      value: { ..._ },
    })),
    account: {
      label: startCase(_data?.account?.replace("_", " ").toLowerCase()),
      value: _data?.account,
    },
    agency: {
      label: _data?.agency?.name,
      value: { ..._data?.agency },
    },
    agents: _data?.agents?.map((_) => ({
      label: _?.displayName,
      value: { ..._ },
    })),
    leaders: _data?.leaders?.map((_) => ({
      label: _?.displayName,
      value: { ..._ },
    })),

    payment: {
      ..._data?.payment,
      deposits: _data?.payment?.deposits?.map((_) => ({
        ..._,
        dueDate: _.dueDate?.split("T", 1)[0],
      })),
    },

    legal: {
      ..._data.legal,
      contract: {
        label: _data?.legal?.contract?.name,
        value: {
          ..._data?.legal?.contract,
        },
      },
    },
  }
}

const getOrganisationProps = (data) => {
  return {
    account: data?.account,
    agency: data?.agency,
    agents: data?.agents,
    leaders: data?.leaders,
  }
}

const GeneralContainer = ({ data, onSubmit }) => {
  const [isEditing, setIsEditing] = useState(false)

  const openModal = useCallback(async () => {
    setIsEditing(true)
  }, [setIsEditing])

  const closeModal = useCallback(async () => {
    setIsEditing(false)
  }, [setIsEditing])

  return (
    <>
      <CardHeading title="General" onClick={openModal} />

      <About data={data} />
      <Legal data={data?.legal} />
      <Organisation data={getOrganisationProps(data)} />
      <Payment data={data?.payment} />

      <Modal title="Edit Trip General" isOpen={isEditing} onClose={closeModal}>
        <GeneralForm data={data} onClose={closeModal} onSubmit={onSubmit} />
      </Modal>
    </>
  )
}

export default GeneralContainer

const About = ({ data }) => {
  return (
    <div className="">
      <legend className="w-full text-sm font-bold px-4 py-5 sm:px-6 text-gray-400 uppercase tracking-widest">
        About
      </legend>

      <dl>
        <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm leading-5 font-medium text-gray-500">ID</dt>
          <dd className="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
            {data?.code}
          </dd>
        </div>
        <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm leading-5 font-medium text-gray-500">Name</dt>
          <dd className="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
            {data?.name}
          </dd>
        </div>
        <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm leading-5 font-medium text-gray-500">
            Period
          </dt>
          <dd className="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
            {formatDate(data?.startDate, "MMMM d")} -{" "}
            {formatDate(data?.endDate, "MMMM d, yyyy")}
          </dd>
        </div>

        <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm leading-5 font-medium text-gray-500">
            Destinations
          </dt>
          <dd className="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
            {data?.destinations?.map((_) => _?.name)?.join(", ")}
          </dd>
        </div>
      </dl>
    </div>
  )
}

const Legal = ({ data }) => {
  return (
    <div>
      <legend className="w-full text-sm font-bold uppercase tracking-widest px-4 py-5 sm:px-6 mt-5  text-gray-400">
        Legal
      </legend>

      <dl>
        <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm leading-5 font-medium text-gray-500">
            Contract
          </dt>
          <dd className="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
            {data?.contract?.name}
          </dd>
        </div>

        {/* <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm leading-5 font-medium text-gray-500">
            Cancellation Policy
          </dt>
          <dd className="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
            <div
              dangerouslySetInnerHTML={{ __html: data?.cancellationPolicy }}
            />
          </dd>
        </div> */}

        {/* <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm leading-5 font-medium text-gray-500">
            Included
          </dt>
          <dd className="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
            <ul className="flex flex-col list-disc">
              {data?.included?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </dd>
        </div> */}

        {/* <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm leading-5 font-medium text-gray-500">
            Excluded
          </dt>
          <dd className="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
            <ul className="flex flex-col list-disc">
              {data?.excluded?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </dd>
        </div> */}
      </dl>
    </div>
  )
}

const Organisation = ({ data }) => {
  return (
    <div>
      <legend className="w-full text-sm font-bold px-4 py-5 sm:px-6 mt-5  text-gray-400 uppercase tracking-widest">
        Organisation
      </legend>

      <dl>
        <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm leading-5 font-medium text-gray-500">
            Account
          </dt>
          <dd className="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
            <p className="text-sm ">{data?.account.replace("_", " ")}</p>
          </dd>
        </div>

        <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm leading-5 font-medium text-gray-500">
            Agency
          </dt>
          <dd className="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
            <p className="text-sm">{data?.agency?.name}</p>
          </dd>
        </div>

        <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm leading-5 font-medium text-gray-500">
            Agents
          </dt>
          <dd className="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
            <ul>
              {data?.agents?.map((agent, index) => (
                <li key={index}>
                  <p className="text-sm">{agent?.displayName}</p>
                </li>
              ))}
            </ul>
          </dd>
        </div>

        {data?.leaders?.length > 0 && (
          <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm leading-5 font-medium text-gray-500">
              Leaders
            </dt>
            <dd className="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
              <ul>
                {data?.leaders?.map((leader, index) => (
                  <li key={index}>
                    <p className="text-sm">{leader?.displayName}</p>
                  </li>
                ))}
              </ul>
            </dd>
          </div>
        )}
      </dl>
    </div>
  )
}

const Payment = ({ data }) => {
  return (
    <div>
      <legend className="w-full text-sm font-bold px-4 py-5 sm:px-6 mt-5  text-gray-400 uppercase tracking-widest">
        Payment
      </legend>

      <dl>
        <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm leading-5 font-medium text-gray-500">
            Base Price
          </dt>
          <dd className="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
            {formatMoney(data?.price)}
          </dd>
        </div>
        <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm leading-5 font-medium text-gray-500">
            Deposits
          </dt>
          <dd className="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
            <ul>
              {data?.deposits?.map((deposit, index) => (
                <li key={index} className="flex">
                  <p className="mr-4 w-3/12 capitalize">
                    {data?.deposits?.length === 1 ||
                    index !== data?.deposits?.length - 1
                      ? `${stringifyNumber(index + 1)} deposit`
                      : "Final payment"}
                  </p>
                  <p className="text-sm w-3/12">
                    {formatMoney(deposit?.amount)}
                  </p>
                  <p className="text-sm ml-4 w-3/12">
                    {deposit?.dueDate
                      ? formatDate(deposit?.dueDate, "MMMM d, yyyy")
                      : "At registration"}
                  </p>
                </li>
              ))}
            </ul>
          </dd>
        </div>
      </dl>
    </div>
  )
}

const GeneralForm = ({ data, onClose, onSubmit }) => {
  const createTripSchema = yup.object().shape({
    name: yup.string().required("Name is required"),
    code: yup.number().required("Code is required"),
    startDate: yup.date().required("Start date is required"),
    endDate: yup.date().required("End date is required"),
    // destinations: yup
    //   .array("You must have at least one destination")
    //   .required("You must have at least one destination")
    //   .min(1, "You must have at least one destination")
    //   .nullable(),

    image: yup.object().required("Cover image is required").nullable(),

    legal: yup.object().shape({
      contract: yup.object().required("Contract is required").nullable(),
    }),

    account: yup.object().required("Account is required").nullable(),

    agency: yup.object().required("Agency is required").nullable(),

    // agents: yup
    //   .array("You must have at least one agent")
    //   .required("You must have at least one agent")
    //   .min(1, "You must have at least one agent")
    //   .nullable(),

    payment: yup.object().shape({
      price: yup
        .number()
        .nullable()
        .required("Base price is required")
        .min(0, "Based price can't be 0"),

      deposits: yup
        .array()
        .of(
          yup.object({
            amount: yup
              .number()
              .typeError("Amount must be a number")
              .nullable()
              .when("$index", (_, schema, { index, parent }) => {
                return parent.amount
                  ? schema
                      .min(1, "Amount more then 0")
                      .required("Amount is required")
                  : schema
              }),
            dueDate: yup
              .date()
              .when("$index", (_, schema, { index }) => {
                return index === 0
                  ? schema
                  : schema.required("Due date is required")
              })
              .nullable(),
          }),
        )
        .test(
          "sales-sum-test",
          "Deposit sum is more or equal to base price",
          function (deposits, { parent }) {
            const total = parent?.price
            const sum = deposits.reduce(
              (sum, item) => (sum += item.amount ? item.amount : 0),
              0,
            )

            return total >= sum
          },
        ),
    }),
  })

  const formikProps = {
    initialValues: {
      name: "",
      code: "",
      startDate: "",
      endDate: "",
      // location: "",
      destinations: [],
      image: null,

      legal: {
        contract: null,
      },

      agency: null,
      agents: [],
      leaders: [],

      payment: {
        price: null,
        deposits: [
          { amount: 0 }, //'First deposit
          { amount: 0, dueDate: "" }, //Final payment
        ],
      },

      ...getTripEditModalProps(data),
    },
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: createTripSchema,
    onSubmit: async (values, actions) => {
      try {
        const input = {
          ...values,
          destinations: values?.destinations?.map((_) => _.value),
          image: {
            id: values?.image?.id,
            name: values?.image?.name,
            url: values?.image?.url,
          },

          payment: {
            ...values.payment,
            deposits: values?.payment?.deposits.map((part) => {
              const { id, ...rest } = part
              return rest
            }),
          },
          legal: {
            ...values.legal,
            contract: { ...values.legal.contract.value },
          },

          account: values?.account?.value,
          agency: { ...values.agency.value },
          agents: values.agents.map((_) => _.value),
          leaders: values.leaders.map((_) => _.value),
        }

        await onSubmit(input)
        await onClose()
      } catch (e) {
        // const errors = e.graphQLErrors.map(v => v)
        // setFieldError("server", errors)
      }
    },
  }

  return (
    <Formik {...formikProps}>
      {({ values, errors }) => (
        <Form>
          <TripGeneralForm values={values} />
          <button type="submit" className="btn-submit">
            Submit
          </button>
        </Form>
      )}
    </Formik>
  )
}
